import { PORTAL_API_BASE_URL } from '../../../../constants';
import { getAccessToken } from '../../../core/auth/utils';

/**
 * POST /api/admin/me/partner-logout — terminate partner LMS sessions before Auth0 logout.
 */
export const triggerPartnerLogout = async () => {
  const headers = new Headers();
  headers.append('Authorization', `Bearer ${await getAccessToken()}`);
  headers.append('Content-type', 'application/json');

  return fetch(`${PORTAL_API_BASE_URL}/api/admin/me/partner-logout`, {
    headers,
    method: 'POST',
  });
};
